import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-human-resources',
    templateUrl: './human-resources.component.html',
    styleUrls: ['./human-resources.component.scss'],
    host: { 'class': 'cell auto grid-y cell-block-y blockContent' },
    standalone: false
})
export class HumanResourcesComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
